<template>
  <div class="contact-w">
    <img class="top-img" src="../../assets/img/contact/img-t.png" alt="">
    <div class="contact-tabs">
      <el-tabs v-model="activeName">
        <el-tab-pane label="业务合作" name="first">
          <div class="js-w">
            <div class="js-l">
              <div class="jsl-t">恒安卫士(深圳)电子科技发展有限公司北京科技分公司</div>
              <div class="line"></div>
              <div class="jsl-i">地址：北京市丰台区卢沟桥街道大瓦窑北路1号院3号楼</div>
              <div class="jsl-i">电话：(010) 8373 8811</div>
              <div class="jsl-i">邮编：100166</div>
              <div class="jsl-i">邮箱：545458@hengan</div>
            </div>
            <div class="js-r"></div>
          </div>
          <!-- <img class="js-bd" src="../../assets/img/contact/bd.png"> -->
          <bmap></bmap>
        </el-tab-pane>
        <el-tab-pane label="人才招聘" name="second">
          <div class="zp-w">
            <div class="zp-t">
              <img src="../../assets/img/contact/work.png" alt="工作环境">
            </div>
            <div class="hj-card">
              <el-carousel type="card" indicator-position="none" arrow="always" height="332px" width="587px">
                <el-carousel-item v-for="item in HJData" :key="item.id">
                  <img :src="item.img" class="tech-img">
                </el-carousel-item>
              </el-carousel>
            </div>
            <div class="zp-t">
              <img src="../../assets/img/contact/fuli.png" alt="员工福利">
            </div>
            <div class="fl-s">
              <img src="../../assets/img/contact/fulis.png" alt="员工福利">
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import bmap from '../lib/Bmap.vue'
export default {
  name: 'contactus',
  components: {bmap},
  data () {
    return {
      activeName: 'first',
      HJData: [
        {id: 1, img: require('../../assets/img/contact/hj1.png')},
        {id: 2, img: require('../../assets/img/contact/hj2.png')},
        {id: 3, img: require('../../assets/img/contact/hj3.png')},
        {id: 4, img: require('../../assets/img/contact/hj4.png')}
      ]
    }
  }
}
</script>
<style scoped>
.top-img{
  width: 100%;
  height: 400px;
}
.contact-tabs{
  width: 1200px;
  margin: 20px auto 100px;
}
.js-w{
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin: 69px 0 90px;
}
.js-l{
  width: 496px;
}
.jsl-t{
  font-size: 30px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #333333;
  line-height: 40px;
}
.line{
  width: 58px;
  height: 6px;
  background: #CCCCCC;
  margin: 35px 0;
}
.jsl-i{
  width: 475px;
  height: 40px;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #333333;
  line-height: 40px;
}
.js-r{
  width: 589px;
  height: 353px;
  background: url('../../assets/img/contact/hakj.png');
  background-size: 100%;
}
.js-bd{
  width: 100%;
  height: 400px;
  margin: 90px 0 0;
}
.zp-t{
  width: 256px;
  height: 29px;
  margin: 80px auto;
}
.zp-t img{
  width: 100%;
  height: 100%;
}
.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}
.fl-s{
  width: 1200px;
  height: 180px;
  margin: 0 auto 90px;
}
.fl-s img{
  width: 100%;
  height: 100%;
}
.tech-img{
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/view/contact.vue